import React, { useState } from 'react';
import { Microscope, Rocket, BookOpen, FlaskConical } from 'lucide-react';
import GettingStartedTab from './research/GettingStartedTab';
import PublicationResourcesTab from './research/PublicationResourcesTab';
import ActiveProjectsTab from './research/ActiveProjectsTab';
import TabStrip from '../shared/TabStrip';
import ToolHeader from '../shared/ToolHeader';

export const RESEARCH_ACCENT = '#047857';

const TABS = [
  { id: 'getting-started', label: 'Getting Started', icon: Rocket },
  { id: 'publication', label: 'Publishing', icon: BookOpen },
  { id: 'projects', label: 'Active Projects', icon: FlaskConical },
];

const ResearchHubScreen = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('getting-started');
  return (
    <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-900 min-h-screen">
      <ToolHeader title="Research Hub" subtitle="From first question to publication" icon={Microscope} accent={RESEARCH_ACCENT} backLabel="Home" onBack={onBack} />
      <TabStrip tabs={TABS} activeTab={activeTab} onChange={setActiveTab} activeClass="border-emerald-700 dark:border-emerald-400 text-emerald-700 dark:text-emerald-400" />
      <div className="p-6">
        {activeTab === 'getting-started' && <GettingStartedTab />}
        {activeTab === 'publication' && <PublicationResourcesTab />}
        {activeTab === 'projects' && <ActiveProjectsTab />}
      </div>
      <div className="h-8" />
    </div>
  );
};

export default ResearchHubScreen;
